<template>
  <base-draggable-modal
      name="certificate_import"
      max-height="80vh"
      width="50vw"
      :fullscreen="$vuetify.display.xsOnly"
      ref="certificate_import">
    <v-card rounded="xl">
      <base-modal>
        <template #header>
          <v-toolbar class="draggable_selector" flat color="secondary" density="compact">
            <v-toolbar-title class="text-primary">{{ $store.getters.translate('certificate_files') }}</v-toolbar-title>
          </v-toolbar>
        </template>
        <template #content>
          <v-card-text>
            <v-row>
              <v-col v-cloak @drop.prevent="addDropFile" @dragover.prevent>
                <v-file-input
                    v-model="new_files"
                    :multiple="true"
                    :label="$store.getters.translate('files')"
                    placeholder="Drop file to upload"
                    color="primary"
                    bg-color="white"
                    density="compact"
                    hide-details
                    show-size/>
              </v-col>
            </v-row>
          </v-card-text>
        </template>
        <template #footer>
          <v-card-text>
            <v-row>
              <v-col>
                <base-action-button :width="'100%'" @action="closeModal('certificate_import')">
                  <template #prepend><PhX style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
                  {{ $store.getters.translate("cancel") }}
                </base-action-button>
              </v-col>
              <v-col>
                <base-action-button :background="true" :width="'100%'" @action="uploadFiles">
                  <template #prepend><PhArrowSquareIn style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
                  {{ $store.getters.translate("import") }}
                </base-action-button>
              </v-col>
            </v-row>
          </v-card-text>
        </template>
      </base-modal>
    </v-card>
  </base-draggable-modal>
</template>

<script>
import helpFunctions from "../../plugins/helpFunctions";
import BaseModal from "./BaseModal";
import BaseDraggableModal from "./BaseDraggableModal";
import BaseActionButton from "./BaseActionButton";
import {PhArrowSquareIn, PhX} from "@phosphor-icons/vue";

export default {
  components: {
    BaseActionButton,
    BaseModal,
    BaseDraggableModal,
    PhArrowSquareIn, PhX,
  },
  data() {
    return {
      page: helpFunctions.pages.inspectioncertificates,
      new_files: []
    };
  },
  methods: {
    ...helpFunctions.modal_functions,
    async load() {
      this.new_files = [];
      this.openModal('certificate_import');
    },
    addDropFile(e) {
      for (let i = 0; i < e.dataTransfer.files.length; i++) {
        this.new_files.push(e.dataTransfer.files[i]);
      }
    },
    async uploadFiles() {
      if(this.new_files.length > 0) {
        const formData = new FormData();
        for (let i = 0; i < this.new_files.length; i++) {
          formData.append("attachment[]", this.new_files[i]);
        }
        this.$store.dispatch('setLoader', true);
        await this.$http.post(this.$store.getters.appUrl + "v2/" + this.page.name + "/uploadfilesbulk", formData, {headers: {"Content-Type": "multipart/form-data"}});
        this.$store.dispatch('setLoader', false);
        this.new_files = [];
        this.$toast.success(this.$store.getters.translate("success"));
        this.$emit('refresh');
        this.closeModal('certificate_import');
      }
    },
  }
};
</script>